import React from 'react';
import './about.css';
import Resume from '../../assets/My_Resume.pdf';

const About = () => {
  const stats = [
    {
      icon: 'bx bx-briefcase-alt',
      title: 'Experience',
      subtitle: 'Professional',
    },
    {
      icon: 'bx bx-code-alt',
      title: 'Completed',
      subtitle: '30+ Projects',
    },
    {
      icon: 'bx bx-support',
      title: 'Support',
      subtitle: '17/7 Online',
    },
  ];

  return (
    <section className="about section" id="about">
      <div className="container">
        <div className="section__header reveal">
          <span className="section__label">About Me</span>
          <h2 className="section__title">Who I Am</h2>
          <p className="section__subtitle">Discover my journey and passion for technology</p>
        </div>

        <div className="about__content">
          <div className="about__info-cards reveal">
            {stats.map((stat, index) => (
              <div className="about__card" key={index}>
                <div className="about__card-icon">
                  <i className={stat.icon}></i>
                </div>
                <h3 className="about__card-title">{stat.title}</h3>
                <span className="about__card-subtitle">{stat.subtitle}</span>
              </div>
            ))}
          </div>

          <div className="about__text reveal">
            <p className="about__description">
              I'm a passionate and dedicated tech enthusiast currently pursuing 
              <strong> B.Tech in Data Science and Artificial Intelligence </strong> 
              at IIIT Naya Raipur. My expertise spans across 
              Data Analytics, Machine Learning, and Full Stack Web Development. 
              I love transforming complex problems into elegant, user-friendly solutions.
            </p>

            <p className="about__description">
              From building intelligent analytics platforms at American Express to developing 
              full-stack applications with modern technologies, I bring a unique blend of 
              data-driven thinking and engineering excellence to every project I work on.
            </p>

            <div className="about__highlights">
              <div className="about__highlight">
                <span className="about__highlight-dot"></span>
                <span>Currently based in Raipur, India</span>
              </div>
              <div className="about__highlight">
                <span className="about__highlight-dot"></span>
                <span>Open to new opportunities</span>
              </div>
              <div className="about__highlight">
                <span className="about__highlight-dot"></span>
                <span>Focused on AI/ML & Full Stack</span>
              </div>
            </div>

            <a download="" href={Resume} className="btn btn--primary about__resume-btn" id="download-resume-btn">
              <span>Download Resume</span>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 15.25L12 4.75" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M7.5 10.75L12 15.25L16.5 10.75" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M4.75 19.25H19.25" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;